import { takeEvery, put, call } from "redux-saga/effects"
import axios from "axios";
import { API_SERVICE_UPDATE } from "ApiConfig";
import {jwtDecode} from "jwt-decode"
import {
   PROFIL_GET,
   ABOUTUS_GET,
   SERVICES_GET,
   CERTIFICATES_GET,
   PASSWORD_GET,
   PASSWORD_SET
} from "./actionTypes";

import {
   Profil_SET,
   Aboutus_SET,
   Services_SET,
   Certificates_SET,
} from "./actions"
import { notify } from "store/notification/action";


function* Profil({ data }) {

   async function API() {
      var client = jwtDecode(localStorage.getItem("authUser"))
      var id = client.client_id

      const response = await axios
         .post(`${API_SERVICE_UPDATE}UpdateProfil`, {
            client_id: id,
            fullname: data.fullname,
            gender: data.gender,
            email: data.email,
            address: data.address,
            phone: data.phone,
            city: data.city,
            county: data.county,
            postcode: data.postcode,
            token: JSON.parse(localStorage.getItem("authUser")),
         })
         .then(response => response)
         .catch(err => {
            console.log("Bitmedi")
            // LoginButtonStatus(dispatch,"a")
         })

    
      return response.data
   }

   // Login İşleminde Sunucudan Dönen Yanıt
   const datam = yield call(API)

   yield put(Profil_SET(datam))

  
}


function* Aboutus({ data }) {
   async function API() {
      var client = jwtDecode(localStorage.getItem("authUser"))
      var id = client.client_id

      const response = await axios
         .post(`${API_SERVICE_UPDATE}UpdateAboutus`, {
            client_id: id,
            about: data.about,
            summary: data.summary,
            token: JSON.parse(localStorage.getItem("authUser")),
         })
         .then(response => response)
         .catch(err => {
            console.log("Bitmedi")
            // LoginButtonStatus(dispatch,"a")
         })


      return response.data
   }

   // Login İşleminde Sunucudan Dönen Yanıt
   const datam = yield call(API)

   yield put(Aboutus_SET(datam))
}

function* Services({data }) {
   
   const x = data.x;


   if(x==0) {

      async function API() {
         var client = jwtDecode(localStorage.getItem("authUser"))
         var id = client.client_id
   
         const response = await axios
            .post(`${API_SERVICE_UPDATE}UpdateServices`, {
               client_id: id,
               x:0,
               name:data.name,
               mission:data.data,
               token: JSON.parse(localStorage.getItem("authUser")),
            })
            .then(response => response)
            .catch(err => {
               console.log("Bitmedi")
               // LoginButtonStatus(dispatch,"a")
            })
   
    
         return response.data
      }
   
      // Login İşleminde Sunucudan Dönen Yanıt
      const datam = yield call(API)
   
      yield put(Services_SET(datam))

   }
   else {
      async function API() {
         var client = jwtDecode(localStorage.getItem("authUser"))
         var id = client.client_id
   
         const response = await axios
            .post(`${API_SERVICE_UPDATE}UpdateServices`, {
               client_id: id,
               x:1,
               name:data.name,
               mission:data.data,
               token:JSON.parse(localStorage.getItem("authUser")),
            })
            .then(response => response)
            .catch(err => {
               console.log("Bitmedi")
               // LoginButtonStatus(dispatch,"a")
            })
   
    
         return response.data
      }
   
      // Login İşleminde Sunucudan Dönen Yanıt
      const datam = yield call(API)
   
      yield put(Services_SET(datam))
   }


      
}

function* Certificates({ data }) {
   console.log("Sagadayım")

   async function API() {
      var client = jwtDecode(localStorage.getItem("authUser"))
      var id = client.client_id

      const response = await axios
         .post(`${API_SERVICE_UPDATE}UpdateCertificates`, {
            client_id: id,
            status: data.status,
            id: data.id,
            token: JSON.parse(localStorage.getItem("authUser")),
         })
         .then(response => response)
         .catch(err => {
            console.log("Bitmedi")
            // LoginButtonStatus(dispatch,"a")
         })


      return response.data
   }

   // Login İşleminde Sunucudan Dönen Yanıt
   const datam = yield call(API)
   console.log(datam)

   yield put(Certificates_SET(datam)) 
}

function* Password({password}) {


   async function API() {
      var client = jwtDecode(localStorage.getItem("authUser"))
      var id = client.client_id

      const response = await axios
         .post(`${API_SERVICE_UPDATE}PasswordChange`, {
            client_id: id,
            password: password,
            token: JSON.parse(localStorage.getItem("authUser")),
         })
         .then(response => response)
         .catch(err => {
            console.log("Bitmedi")
         })

    
      return response.data
   }

   // Password İşleminde Sunucudan Dönen Yanıt
   const datam = yield call(API)

   yield put(notify(datam))




}


function* AllProfil() {

   yield takeEvery(PROFIL_GET, Profil)
   yield takeEvery(ABOUTUS_GET, Aboutus)
   yield takeEvery(SERVICES_GET, Services)
   yield takeEvery(CERTIFICATES_GET, Certificates)
   yield takeEvery(PASSWORD_SET, Password)
}

export default AllProfil



